import { Link } from 'react-router';
import styles from './ActionLink.module.css';

/** A navigation link styled as a 28px-high button (header actions, "View all", "Manage"...). */
const ActionLink = ({ to, children, ...rest }) => (
    <Link to={to} className={styles.link} {...rest}>
        {children}
    </Link>
);

export default ActionLink;
